// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'
import {SeqId} from './seq-id.js'

export class InsertString {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): InsertString {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsInsertString(bb: flatbuffers.ByteBuffer, obj?: InsertString): InsertString {
    return (obj || new InsertString()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsInsertString(bb: flatbuffers.ByteBuffer, obj?: InsertString): InsertString {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new InsertString()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  location(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  string(): string | null
  string(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  string(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  textField(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startInsertString(builder: flatbuffers.Builder) {
    builder.startObject(3)
  }

  static addLocation(builder: flatbuffers.Builder, locationOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, locationOffset, 0)
  }

  static addString(builder: flatbuffers.Builder, stringOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, stringOffset, 0)
  }

  static addTextField(builder: flatbuffers.Builder, textFieldOffset: flatbuffers.Offset) {
    builder.addFieldStruct(2, textFieldOffset, 0)
  }

  static endInsertString(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 6) // string
    return offset
  }
}
